import { type Dispatch, useEffect } from 'react';

import { getLastSearchCar } from 'shared/search/common/lastSearch';
import actions from '../../../car/carActions';
import type { CarState } from '../../../car/carDefaultState';

export const useCarInitialState = (dispatch: Dispatch<ReturnType<(typeof actions)[keyof typeof actions]>>, prefill?: Partial<CarState>) => {
    useEffect(() => {
        dispatch(actions.allFieldsChanged({ ...getLastSearchCar(), ...prefill }));
    }, [dispatch, prefill]);
};
